import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TeamMemberRow, TeamRosterData } from '../../../interfaces/metrics';

@Component({
  selector: 'bst-team-roster',
  templateUrl: './team-roster.component.html',
  styleUrls: ['./team-roster.component.scss'],
  standalone: false,
})
export class TeamRosterComponent {
  @Input() data!: TeamRosterData;
  @Output() memberSelected = new EventEmitter<{ userId: number; name: string }>();

  filter = '';

  // Client-side name filter over the already-loaded roster (matches the market
  // keyword-search idiom).
  //
  // No bench-collapse here on purpose: this used to fold every 0%-utilization member
  // into a single "on the bench" summary row, but 0% utilization this period is not the
  // same fact as "not actively assigned". TeamRosterResolver computes utilization from
  // billableHours/capacityHours for the CURRENT period only, so an actively-assigned
  // member with no hours logged yet (e.g. Monday morning) reads identically to someone
  // truly unassigned - and the row payload has no field that tells the two apart
  // (AssignmentsEndingResolver's 'empty' vs 'ok' state, which WOULD distinguish them,
  // is discarded before assignmentEndsOn reaches this row). Collapsing on an ambiguous
  // signal hid the exact columns (timesheet status, assignment end date) a real bench
  // member needs and an about-to-log-hours member does not, so every row now stays
  // individually visible with its true 0% reading instead of a false "on the bench" label.
  get rows(): TeamMemberRow[] {
    const q = this.filter.trim().toLowerCase();
    const all = this.data?.rows ?? [];
    return q ? all.filter(r => r.name.toLowerCase().includes(q)) : all;
  }

  clearFilter(): void { this.filter = ''; }

  select(row: { userId: number; name: string }, event: Event): void {
    event.stopPropagation();   // do not also trigger the widget-card click
    this.memberSelected.emit({ userId: row.userId, name: row.name });
  }
}
